import React from 'react';
import {
  Box,
  FormControl,
  FormLabel,
  Input,
  Textarea,
  Button,
  useToast,
  Select,
  FormErrorMessage,
  Text,
} from '@chakra-ui/react';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import { useStores } from '../../store/store_context';
import UsersSearch from '../users_autocomplete';
import { useState } from 'react';

// Валидационная схема для Formik и Yup
const validationSchema = Yup.object().shape({
  adress: Yup.string().required('Обязательное поле'),
  model_url: Yup.string().required('Обязательное поле'),
  fabric_number: Yup.string().required('Обязательное поле'),
  comment: Yup.string(),
  dimensions: Yup.string().required('Обязательное поле'),
});

const dimensionsOptions = [
  '540:1920',
  '1080:2560',
  '1080:1920',
  '1920:1080',
  '2560:1080',
  '1920:540',
  // добавьте здесь другие разрешения, если нужно
];

// Компонент формы для просмотра и изменения данных пользователя
const PanelCreateForm = ({
  initialValues,
  onSubmit,
  updatePanelsTable,
  usersForPanelForm,
  changeTab,
}) => {
  const { pageStore } = useStores();

  const [userId, setUserId] = useState();

  const toast = useToast();

  const handleSubmit = async (values, actions) => {
    try {
      await onSubmit(values, userId, pageStore.token);
      toast({
        title: 'Панель успешно создана.',
        status: 'success',
        duration: 3000,
        isClosable: true,
      });
    } catch (error) {
      console.error('Ошибка при отправке данных:', error);
      toast({
        title: 'Ошибка',
        description: 'Что-то пошло не так. Пожалуйста, попробуйте снова.',
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    } finally {
      await updatePanelsTable();
      actions.setSubmitting(false);
    }
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {({ errors, touched }) => (
        <Form>
          <Text>
            Начните вводить никнейм пользователя для первоначальной привязки
            панели к нему
          </Text>
          <UsersSearch
            items={usersForPanelForm.map(elem => {
              return { id: elem.user_id, name: elem.username };
            })}
            setResult={setUserId}
          />

          <Field name="adress">
            {({ field }) => (
              <FormControl isInvalid={errors.adress && touched.adress}>
                <FormLabel htmlFor="adress">Адрес установки:</FormLabel>
                <Input {...field} id="adress" />
              </FormControl>
            )}
          </Field>
          <Field name="model_url">
            {({ field }) => (
              <FormControl isInvalid={errors.model_url && touched.model_url}>
                <FormLabel htmlFor="model_url">модель нейросети:</FormLabel>
                <Input {...field} id="model_url" />
              </FormControl>
            )}
          </Field>

          <Field name="fabric_number">
            {({ field }) => (
              <FormControl
                isInvalid={errors.fabric_number && touched.fabric_number}
              >
                <FormLabel htmlFor="fabric_number">
                  Производственный номер:
                </FormLabel>
                <Input {...field} id="fabric_number" />
              </FormControl>
            )}
          </Field>
          <Field name="comment">
            {({ field }) => (
              <FormControl isInvalid={errors.comment && touched.comment}>
                <FormLabel htmlFor="comment">Комментарий:</FormLabel>
                <Input {...field} id="comment" />
              </FormControl>
            )}
          </Field>
          <Field name="dimensions">
            {({ field }) => (
              <FormControl isInvalid={errors.dimensions && touched.dimensions}>
                <FormLabel htmlFor="dimensions">Разрешение:</FormLabel>
                <Select {...field} id="dimensions">
                  {dimensionsOptions.map(option => (
                    <option
                      key={option}
                      style={{ color: 'black' }}
                      value={option}
                    >
                      {option}
                    </option>
                  ))}
                </Select>
                <FormErrorMessage>{errors.dimensions}</FormErrorMessage>
              </FormControl>
            )}
          </Field>

          <Button
            mt={4}
            colorScheme="blue"
            type="submit"
            backgroundColor={'#7B79FF'}
            _hover={{ backgroundColor: '#4945FF' }}
            color="white"
            onClick={() => changeTab(0)}
          >
            Сохранить
          </Button>
        </Form>
      )}
    </Formik>
  );
};

export default PanelCreateForm;
